import { render, staticRenderFns } from "./formDisabled.vue?vue&type=template&id=5224dc84&"
import script from "./formDisabled.vue?vue&type=script&lang=js&"
export * from "./formDisabled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports